class RegisterForm extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.form = this.querySelector('.customer-register__form');
    this.password = this.querySelector('.register-form-password');
    this.confirmPassword = this.querySelector('.register-form-confirm-password');
    this.button = this.querySelector('.register-form-submit');
    this.nonEmptyTestFields = this.querySelectorAll('.field-empty-check');
    this.validationCheckboxes = {
      fields: this.querySelector('#customer-register-fields-validation'),
      passwordMatch: this.querySelector('#customer-register-password-match'),
    };
    this.tests = {
      fieldsValidated: false,
      passwordMatch: false,
    };

    this.attachEventListeners();
  }

  attachEventListeners() {
    this.nonEmptyTestFields.forEach((field) =>
      field.addEventListener('input', () => {
        this.checkEmptyFields();
        this.checkButton();
      })
    );

    this.confirmPassword.addEventListener('input', () => {
      this.testPasswordMatch();
      this.checkButton();
    });

    this.password.addEventListener('input', () => {
      this.testPasswordMatch();
      this.checkButton();
    });

    this.form.addEventListener('submit', (event) => this.validateForm(event));
  }

  testPasswordMatch() {
    this.tests.passwordMatch = this.confirmPassword.value == this.password.value;
    this.validationCheckboxes.passwordMatch.checked = this.tests.passwordMatch;
  }

  checkEmptyFields() {
    const maxTests = this.nonEmptyTestFields.length;
    let testsPassed = 0;
    this.nonEmptyTestFields.forEach((field) => {
      if (field.value.length !== 0) {
        testsPassed++;
      }
    });

    const isValid = testsPassed == maxTests;
    this.tests.fieldsValidated = isValid;
    this.validationCheckboxes.fields.checked = isValid;
    return isValid;
  }

  checkButton() {
    this.button.disabled = !Object.values(this.tests).every((test) => test);
  }

  validateForm(event) {
    if (!this.checkEmptyFields() || !this.testPasswordMatch()) {
      event.preventDefault();
    }
  }
}

customElements.define('register-form', RegisterForm);
